import { List } from 'lucide-react';
import { useVisit } from '../../VisitContext';
import { VisitStatusEnum } from '@generated';
import { Section } from '~/shared/section/Section';
import { InterventionTable } from '~/features/careplanning/goals-interventions/interventions/InterventionTable';
import { VisitTimeInOut } from './VisitTimeInOut';
import { SubmitVisit } from './SubmitVisit';
import { NextVisit } from './NextVisit';
import { DateField } from '~/shared/forms/controls/base-fields/DateField';
import { convertToDateFieldValue } from '~/util/date';
import { TextField } from '~/shared/forms/controls/base-fields/TextField';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { VisitBucketItemWrapper } from '../../shared/VisitBucketItemWrapper';
import { VisitSummaryFooter } from './VisitSummaryFooter';

export function VisitSummaryBucket() {
	const { visitStatusId, documentationTime, associatedMileage, travelTimeInUtc, travelTimeOutUtc, plannedForNextVisit } = useVisit();

	if (visitStatusId === VisitStatusEnum.InProgress) {
		return (
			<VisitBucketItemWrapper footerSlot={<VisitSummaryFooter />}>
				<Section header={<SectionTitle TitleIcon={List} title="Visit Summary" description="Track visit timing and travel information" />}>
					<VisitTimeInOut />
				</Section>
			</VisitBucketItemWrapper>
		);
	} else if (visitStatusId === VisitStatusEnum.Ended) {
		return (
			<VisitBucketItemWrapper>
				<Section header={<SectionTitle TitleIcon={List} title="Visit Summary" description="Track visit timing and travel information" />}>
					<div className="space-y-8">
						<VisitTimeInOut />
						<SubmitVisit />
					</div>
				</Section>
			</VisitBucketItemWrapper>
		);
	}

	return (
		<VisitBucketItemWrapper>
			<Section header={<SectionTitle TitleIcon={List} title="Visit Summary" description="Track visit timing and travel information" />}>
				<div className="space-y-8">
					<VisitTimeInOut />
					<div className="grid grid-cols-4 gap-6">
						<TextField label="Documentation Time" value={documentationTime?.toString()} isReadOnly />
						<TextField label="Associated Mileage" value={associatedMileage?.toString()} isReadOnly />
						<DateField
							label="Travel Time In"
							granularity="minute"
							isReadOnly
							value={travelTimeInUtc ? convertToDateFieldValue(travelTimeInUtc, 'minute') : null}
						/>
						<DateField
							label="Travel Time Out"
							granularity="minute"
							isReadOnly
							value={travelTimeOutUtc ? convertToDateFieldValue(travelTimeOutUtc, 'minute') : null}
						/>
					</div>
					<div className="space-y-4">
						<div className="flex items-center justify-between gap-3">
							<p className="font-semibold">Plan for next visit:</p>
							<NextVisit />
						</div>

						<InterventionTable rows={plannedForNextVisit.map(x => x.intervention)} />
					</div>
				</div>
			</Section>
		</VisitBucketItemWrapper>
	);
}
